import { setToken } from '../../utils/auth';
import { validatNumberAndChart } from '../../common/validate';
import { getVerifyCodeImg } from '@/api/user';
import { ssoLogon, appLogon } from '@/api/baseMsg';
import { encryptedData } from '../../utils/JSEncrypt';
import { asyncRoutes } from '@/router';
import { Toast } from 'vant';
import wx from 'weixin-js-sdk';
import { loading } from '@/common/loading';
import smsView from './sms.vue';
export default {
  name: 'login',
  components: { smsView },
  data() {
    return {
      isflooerTop: '92%',
      loginForm: {
        phone: '',
        username: '',
        password: '',
        checkVerification: '',
        passwordEncry: '',
        usernameEncry: '',
        openId: this.$route.query.openId ? this.$route.query.openId : '',
        uuid: ''
      },
      focus: {
        field: '',
        isTop: false,
        userFocus: false,
        pwdFocus: false,
        codeFocus: false
      },
      error_message: '',
      userId: this.$route.query.userId ? this.$route.query.userId : '',
      code: this.$route.query.code ? this.$route.query.code : '',
      userName: this.$route.query.userName ? this.$route.query.userName : '',
      imgUrl: null,
      showflag: false,
      passwordType: 'password',
      smsPopup: {
        show: false
      }
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.getContentHeader();
    });
    this.yzmClick();
    this.showflag = true;
    loading(false);
    this.loginForm.openId = sessionStorage.getItem('wxOpenId');
    // this.initData()
  },
  methods: {
    // 获取内容高度
    getContentHeader() {
      const h1 = this.$refs.ref_header_pla.clientHeight;
      const h2 = this.$refs.ref_header_title.clientHeight;
      const h3 = this.$refs.ref_header_form.clientHeight;
      this.$set(this, 'isflooerTop', h1 + h2 + h3 + 28 + 'px');
    },

    switchPasswordType() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
    },
    initData() {
      // window.location.href = 'https://ezapp.cs01.site/webapp'
      // return
      if (this.code == 200) {
        this.showflag = false;
        Toast.loading({
          message: '跳转中，请稍后...',
          duration: 0, // 持续展示 toast
          loadingType: 'spinner',
          className: 'toast'
        });
        this.ssoLogon(this.userName);
      } else {
        this.showflag = true;
      }
    },
    // 直接登录
    ssoLogon(userName) {
      ssoLogon({
        userName: encryptedData(userName.trim())
      }).then((res) => {
        if (res.code === 200) {
          setToken(res.data.token);
          this.$store.commit('login/SET_LOGINUSERFORM', userName);
          this.$store.commit('login/SET_LOGINTYPE', 1);
          if (res.data.user.ifSystem == 1) {
            this.$router.push({ path: '/' });
          } else {
            this.$router.push({ path: '/jiagecaijiTB/jiagecaiji' });
          }
        } else {
          this.$router.push({ path: '/error' });
        }
        Toast.clear();
      });
    },
    // 用户名-密码-验证码登录
    handleLogin() {
      if (!this.loginForm.username) {
        return this.isClick();
      }
      if (!this.loginForm.password) {
        return this.isClickP();
      }
      if (!this.loginForm.checkVerification) {
        return this.isClickV();
      }
      Toast.loading({
        message: '跳转中，请稍后...',
        duration: 0, // 持续展示 toast
        loadingType: 'spinner',
        className: 'toast'
      });
      this.loginForm.passwordEncry = encryptedData(this.loginForm.password); // 加密数据
      this.loginForm.usernameEncry = encryptedData(this.loginForm.username.trim()); // 加密数据
      appLogon({
        userName: this.loginForm.usernameEncry,
        passWord: this.loginForm.passwordEncry,
        verifyCode: this.loginForm.checkVerification,
        openId: this.loginForm.openId,
        UUID: this.loginForm.uuid
      }).then((res) => {
        if (res.code === 200) {
          this.smsPopup.show = false;
          setToken(res.data.token);
          this.$store.commit('login/SET_LOGINUSERFORM', this.loginForm.username);
          this.$store.commit('login/SET_LOGINTYPE', 1);
          this.$store.commit('SET_NAME', this.loginForm.username);

          this.$store.dispatch('getListTreeFuns').then((res1) => {
            const data = res1.data;
            this.$store.dispatch('permissionFuns/generateRoutes', data).then((res2) => {
              res2.forEach((i) => {
                asyncRoutes.push(i);
              });
              const resultRouter = asyncRoutes;
              this.$router.addRoutes(resultRouter);
              if (res.data.user.ifSystem == 1) {
                this.$router.push({ path: '/' });
              } else {
                this.$router.push({ path: '/jiagecaijiTB/jiagecaiji' });
              }
            });
          });
        } else if (res.code == 513) {
          // 双因子登录
          this.loginForm.phone = res.data;
          this.smsPopup.show = true;
        } else {
          this.error_message = res.message || '登录失败';
          this.loginForm.password = '';
          this.loginForm.checkVerification = '';
          this.loginForm.passwordEncry = '';
          this.loginForm.usernameEncry = '';
          this.loginForm.uuid = '';
          this.yzmClick();
        }
        Toast.clear();
      });
    },
    yzmClick() {
      getVerifyCodeImg().then((res) => {
        if (res.code == 200) {
          this.imgUrl = 'data:image/png;base64,' + res.data.imgBytes;
          this.loginForm.uuid = res.data.uuid;
          loading(false);
        }
      });
    },
    isClick() {
      if (!this.loginForm.username) {
        this.error_message = '请输入账号!';
      } else {
        this.error_message = '';
      }
    },
    isClickV() {
      if (!this.loginForm.checkVerification) {
        this.error_message = '请输入验证码！';
      } else {
        this.error_message = '';
      }
    },
    isClickP() {
      if (!this.loginForm.password) {
        this.error_message = '请输入密码！';
      } else {
        this.error_message = '';
      }
    },
    isDingYue() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        wx.miniProgram.getEnv((res) => {
          if (res.miniprogram) {
            wx.miniProgram.navigateTo({
              url: `/pages/dingyue/dingyue`
            });
          } else {
            // console.log('不在小程序内');
            Toast(res);
          }
        });
      } else {
        Toast('不支持订阅，请在小程序内打开！');
      }
    },
    onClickCloseIcon() {
      this.yzmClick();
      this.loginForm.password = '';
      this.loginForm.checkVerification = '';
      this.loginForm.passwordType = 'password';
    }
  }
};
